// Usage

// Set the CLASS "formActive" to each section
// Set the CLASS "formActive__edit-link" or "formActive__edit-link--ajax" to the edit link of a section
// Set the CLASS "formActive__view-mode" to the non editable part of a section
// Set the CLASS "formActive__edit-mode" to the editable part (form) of a section

const formActive = {
    $formActive: null,
    $formRequested: null,

    init: function ($focusableItem) {
        if (formActive.$formRequested !== null) {
			formActive.$formActive.removeClass('closed').addClass('opened');

            formActive.$formActive
                .find('.formActive__edit-mode')
                .find('a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]')
                .first()
                .focus();
        } else {
            let ScustomTargetObject = null;
            if (typeof $focusableItem === 'object') {
                ScustomTargetObject = $focusableItem;
            } else {
                ScustomTargetObject = formActive.$formActive.find('[class*="formActive__edit-link"]');
            }

            formActive.$formActive.removeClass('opened').addClass('closed');

            // Hack, otherwise the focus is set to the element before the browser rerendered it.
            setTimeout(function () {
                $(window).link_internal({
                    positionModifier: '.header-primary',
                    positionModifierMultiplier: 3,
                    $customTarget: ScustomTargetObject
                });
                formActive.$formActive = null;
            });
        }

        $('.formActive').each(function () {
            const $section = $(this);
            if (!$section.is(formActive.$formActive)) {
                $section.removeClass('opened').addClass('closed');
                $section.find('.alert--success').addClass('hide');
            }
        });
    },

    // Can be call by a click on formActive__edit-link or by a call ajax on success
    editLink: function ($trigger) {
        formActive.$formRequested = $(`#${$trigger.closest('.formActive').attr('id')}`);

        if (formActive.$formActive !== null && formActive.$formActive.find('.is_dirty').length) {
            $('#confirm-changes').remodal().open();

            return;
        }

        formActive.$formActive = formActive.$formRequested;
        formActive.$formActive.find('.alert--success').addClass('hide');
        formActive.init();
    },

    focusOnSubmit: function ($container) {
        if ($container.find('.error-summary').length > 0 && !$container.find('.error-summary').hasClass('hide')) {
            $container.find('.error-summary').attr('tabindex', '-1').focus();
            $container.find('.error-summary [data-module~="link-internal"] ').link_internal({
                positionModifier: linkInternalPositionModifier,
                positionModifierMultiplier: 2
            });
        } else if ($container.find('.alert--success').length > 0 && !$container.find('.alert--success').hasClass('hide') ) {
            formActive.$formRequested = null;
            const $focusableItem = $container.find('.alert--success');
            formActive.init($focusableItem);
        } else {
            formActive.$formRequested = null;
            formActive.init();
        }
    }
};


$(document).on('click', '.formActive__edit-link', function () {
    formActive.editLink($(this));
});

// Cancel link click - with event delegation to also work in AJAX loaded fragments
$(document).on('click', '.formActive__cancel', function () {
    var $container = $(this).closest('form');
    formActive.$formRequested = null;
    // Check if there were any changes in the current form
    if ($container.hasClass('is_dirty')) {
        $('#confirm-changes').remodal().open();
    } else {
        formActive.init();
    }
});

$(document).on('click', '[data-confirm="formActive"]', function () {
    TINK.resetFormFields(formActive.$formActive.find("form"));
    if (formActive.$formRequested !== null) {
        formActive.$formActive = formActive.$formRequested;
    }
    formActive.init();
});
